/* eslint-disable import/no-deprecated */
import { classNames } from '@fullstory/util/fmt';
import React from 'react';
import { useIntl } from 'react-intl';
import { ButtonBase } from '../../components/ButtonBase';
import { Typography } from '../Typography';
import css from './index.module.scss';

interface DayViewProps {
  // the date to display (will use date.getDate())
  date: Date;
  // optional callback for clicks on non-disabled dates
  onDateClick?: (d: Date) => void;
  // callback for calculating whether the day should appear "selected"
  selected?: (d: Date) => boolean;
  // callback for calculating whether the day should appear "highlighted" (i.e. today)
  highlighted?: (d: Date) => boolean;
  // callback for calculating whether the day should appear "inRange" for the range datepicker
  inRange?: (d: Date) => boolean;
  // callback for calculating whether the day should be disabled
  disabled?: (d: Date) => boolean;
  // callback for calculating whether the day should appear as "outOfMonth" (i.e in the MonthScroller)
  outOfMonth?: (d: Date) => boolean;
}

/**
 * @deprecated
 */
export const DayView: React.FC<DayViewProps> = ({
  date,
  onDateClick,
  selected,
  highlighted,
  inRange,
  disabled,
  outOfMonth,
}) => {
  const intl = useIntl();
  const className = classNames(css.dayView, {
    [css.dateSelected]: !!selected && selected(date),
    [css.sameDay]: !!highlighted && highlighted(date),
    [css.inRange]: !!inRange && inRange(date),
    [css.disabled]: !!disabled && disabled(date),
  });
  let color: React.ComponentProps<typeof Typography>['color'] = undefined;

  if (!!disabled && disabled(date)) {
    color = 'neutrals-n5';
  } else if (!!selected && selected(date)) {
    color = 'white';
  } else if (!!outOfMonth && outOfMonth(date)) {
    if (!!inRange && inRange(date)) {
      color = 'neutrals-n3';
    } else {
      color = 'neutrals-n5';
    }
  }

  return (
    <ButtonBase
      data-component="DeprecatedDatepickerDayView"
      component="div"
      onClick={() => onDateClick && onDateClick(date)}
      disabled={!!disabled && disabled(date)}
    >
      <span className={className}>
        <Typography variant="body3" color={color}>
          {intl.formatDate(date, { day: 'numeric' })}
        </Typography>
      </span>
    </ButtonBase>
  );
};
